import { Component, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import * as _ from 'underscore';
import { SharedData } from '../../shared/sharedData';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'AddOrgUnitType',
    templateUrl: 'organizationUnit.html'
})
export class AddOrgUnitTypeComponent {

    public OrganizationUnitTypeData = {
        id: null,
        orgUnitTypeCode: null,
        orgUnitTypeName: null,
        orgUnitTypeNameLocale: null,
        description: null,
        descriptionLocale: null,
        level: null
    };
    public _baseUrl: any;
    public data: any;
    public type: any;


    constructor(
        public route: ActivatedRoute,
        //   public modalService: NgbModal,
        public _global: Configuration,
        public http: HttpClientCustom,
        //   public _sanitizer: DomSanitizer,
        //   public builder: FormBuilder,
        //   public _auth: Auth,
        //   public router: Router,
        public _location: Location,
        public share: SharedData,
        public _toaster: ToasterComponent,
        public translate: TranslateService,
        vcr: ViewContainerRef
    ) {
        this._toaster.setViewRef(vcr);
        this._baseUrl = _global.get('EPMS_BASE_URL');
        let data: any = this.share.getData();
        if (_.isEmpty(data)) {
            this._location.back();
        } else {
            if (data.type === 'ADD') {
                this.data = {};
                this.type = 'ADD';
            } else if (data.type === 'EDIT') {
                this.OrganizationUnitTypeData = data.OrganizationUnitTypeData;
                this.type = 'EDIT';
            } else {
                this.OrganizationUnitTypeData = data.OrganizationUnitTypeData;
                this.type = 'DELETE';

            }
            this._toaster.setViewRef(vcr);
        }
    }

    // when auto-complete value is selected this method fires and payload create
    // public gotNewValue(e, type) {
    //   this.designationModel = e;
    // }

    // Formatter
    // public nameValueFormatter(data: any): string {
    //   return `${data.name}`;
    // }
    // public orgNameValueFormatter(data: any): string {
    //   return `${data.orgName}`;
    // }
    // public autoCompleteListFormatter = (data: any): SafeHtml => {
    //   let html = `<span>${data.name}</span>`;
    //   return this._sanitizer.bypassSecurityTrustHtml(html);
    // }
    // public autoCompleteListFormatterType = (data: any): SafeHtml => {
    //   let html = `<span>${data.type}</span>`;
    //   return this._sanitizer.bypassSecurityTrustHtml(html);
    // }

    // // To get list of designation based on keyword
    // public designationObservableSource = (keyword: any): Observable<any[]> => {
    //   if (keyword.trim()) {
    //     let url = this._baseUrl + 'v1/webAdmin/designation/designationSearch';
    //     url += '?searchString=' + keyword.trim() + '&id=' + this.OrganizationUnitTypeData.id;
    //     return this.http.get(url)
    //       .map((res) => {
    //         return res;
    //       }, (error) => {
    //         return Observable.of([]);
    //       });
    //   } else {
    //     return Observable.of([]);
    //   }
    // }

    // public autoCompleteListOrgTypeFormatter = (data: any): SafeHtml => {
    //   let html = `<span>${data.orgUnitTypeName}</span>`;
    //   return this._sanitizer.bypassSecurityTrustHtml(html);
    // }

    // // Navigate back
    public goToBackPage() {
        this._location.back();
    }

    deleteOrgUnitType() {
        let url = this._baseUrl + 'v1/webAdmin/orgUnitType/delete/' + this.OrganizationUnitTypeData.id;
        this.http.delete(url).subscribe((result) => {
            if (result.success) {
                this.translate.get('orgUnitTypeDelete').subscribe((msg) => {
                    this._toaster.showSuccess(msg);
                });
                setTimeout(() => this._location.back(), 1000);
                      
            } else {
                let self = this;
                if (result.errorMessages.length > 0) {
                    _.each(result.errorMessages, function (key) {
                        self.translate.get(key).subscribe((msg) => {
                            self._toaster.showError(msg);
                        });
                    });
                }

            }
        });
    }

    public saveOrgUnitType() {
        if (this.validateDesignation()) {
            let url = this._baseUrl + 'v1/webAdmin/orgUnitType/save';
            this.http.post(url, this.OrganizationUnitTypeData).subscribe((result) => {
                if (result.success) {
                    this.translate.get('orgUnitTypeSave').subscribe((msg) => {
                        this._toaster.showSuccess(msg);
                    });
                    setTimeout(() => this._location.back(), 1000);
                } else {
                    this.translate.get(result.errorMessage).subscribe((msg) => {
                        this._toaster.showError(msg);
                    });
                }
            }, (error) => {
                console.log(error);
            });
        }
    }

    public updateOrgUnitType() {
        if (this.validateDesignation()) {
            let url = this._baseUrl + 'v1/webAdmin/orgUnitType/' + this.OrganizationUnitTypeData.id;
            this.http.put(url, this.OrganizationUnitTypeData).subscribe((result) => {
                if (result) {
                    this.translate.get('OrgUnitSaved').subscribe((msg) => {
                        this._toaster.showSuccess(msg);
                    });
                    setTimeout(() => this._location.back(), 1000);
                } else {
                    // this._toaster.showError('Error while adding Designation');
                    this.translate.get(result.errorMessages[0]).subscribe((msg) => {
                        this._toaster.showError(msg);
                    });
                }
            }, (error) => {
                this.translate.get('errorWhileSavingDesignation').subscribe((msg) => {
                    this._toaster.showError(msg);
                });
            });
        }
    }

    // public rangeLimit(event) {
    //   if (event.target.value.length > 11) {
    //     event.target.value.slice(0, 10);
    //   }
    // }

    // public isEmpty(val) {
    //   return !val
    //     || (isString(val) && !val.trim());
    // }

    // public deleteDesgData() {
    //   if (this.empPresent && this.isEmpty(this.designationModel)) {
    //     this.translate.get('altDesigToContinue').subscribe((msg) => {
    //       this._toaster.showError(msg);
    //     });
    //     return false;
    //   }
    //   let url;
    //   if (this.empPresent) {
    //     url = this._baseUrl + 'v1/webAdmin/designation/' + this.OrganizationUnitTypeData.id
    //       + '?alternateId=' + this.designationModel.id;
    //   } else {
    //     url = this._baseUrl + 'v1/webAdmin/designation/' + this.OrganizationUnitTypeData.id;
    //   }

    //   this.http.delete(url).subscribe((result) => {
    //     if (result.success) {
    //       this.translate.get('desigDeletedSuccessfully').subscribe((msg) => {
    //         this._toaster.showSuccess(msg);
    //       });

    //       setTimeout(() => this.goToBackPage(), 1000);
    //     } else {
    //       this.translate.get('erroeWhileDeteleDesig').subscribe((msg) => {
    //         this._toaster.showError(msg);
    //       });

    //       for (let val of result.errorMessages) {
    //         this._toaster.showError(val);
    //       }
    //     }
    //   });
    // }

    public validateDesignation() {
        if (!this.OrganizationUnitTypeData.orgUnitTypeName || !this.OrganizationUnitTypeData.orgUnitTypeName.trim()) {
            this.translate.get('enterUnitName').subscribe((msg) => {
                this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.OrganizationUnitTypeData.orgUnitTypeCode || !this.OrganizationUnitTypeData.orgUnitTypeCode.trim()) {
            this.translate.get('enterUnitCode').subscribe((msg) => {
                this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.OrganizationUnitTypeData.level || this.OrganizationUnitTypeData.level < 1) {
            this.translate.get('pleaseEnterLevelGreaterThanZero').subscribe((msg) => {
                this._toaster.showError(msg);
            });
            return false;
        }
        if (this.OrganizationUnitTypeData.level > 100) {
            this.translate.get('pleaseEnterLevelLessHund').subscribe((msg) => {
                this._toaster.showError(msg);
            });
            return false;
        }
        return true;
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/organizationUnit/organizationUnit.ts